var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cog") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.533 16.687c-1.469-2.544-0.586-5.805 1.973-7.287l-2.751-4.766c-0.786 0.461-1.7 0.725-2.675 0.725-2.94 0-5.324-2.399-5.324-5.359h-5.503c0.007 0.914-0.221 1.84-0.71 2.687-1.469 2.544-4.735 3.41-7.297 1.935l-2.751 4.766c0.792 0.45 1.478 1.11 1.966 1.954 1.467 2.54 0.588 5.795-1.961 7.28l2.751 4.766c0.783-0.457 1.693-0.718 2.663-0.718 2.931 0 5.309 2.384 5.324 5.331h5.503c-0.002-0.904 0.226-1.82 0.71-2.658 1.467-2.54 4.724-3.407 7.285-1.942l2.751-4.766c-0.787-0.45-1.468-1.107-1.953-1.948zM14 19.669c-3.131 0-5.669-2.538-5.669-5.669s2.538-5.669 5.669-5.669c3.131 0 5.669 2.538 5.669 5.669s-2.538 5.669-5.669 5.669z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.4b5fb9ebe59e6a2f8959e825574a44fe.svg";
export { ForwardRef as ReactComponent };